export const PDF_PREVIEW_ZOOM_MAX = 2;
export const PDF_PREVIEW_ZOOM_MIN = 0.1;
export const PDF_PREVIEW_ZOOM_STEP = 0.1;

export const calculatePdfDisplayWidth = (pageWidth: number | undefined, zoom: number): number | undefined => {
	if (typeof pageWidth !== 'number' || Number.isNaN(pageWidth)) {
		return undefined;
	}

	return pageWidth * zoom;
};

export const clampPdfPreviewZoom = (zoom: number): number => {
	if (!Number.isFinite(zoom)) {
		return 1;
	}

	return Math.min(PDF_PREVIEW_ZOOM_MAX, Math.max(PDF_PREVIEW_ZOOM_MIN, zoom));
};

export const resolveInitialPdfPreviewZoom = (
	storedZoom: null | number,
	wrapperWidth: null | number,
	pageWidth: number
): null | number => {
	if (storedZoom !== null) {
		return storedZoom;
	}

	const isWrapperMeasurable = wrapperWidth !== null && Number.isFinite(wrapperWidth) && wrapperWidth > 0;

	if (!isWrapperMeasurable || !Number.isFinite(pageWidth) || pageWidth <= 0) {
		return null;
	}

	return wrapperWidth / pageWidth;
};

export const resolveStoredPdfPreviewZoom = (storedZoomValue: null | string): null | number => {
	if (storedZoomValue === null) {
		return null;
	}

	const parsedZoomValue = Number.parseFloat(storedZoomValue);

	if (!Number.isFinite(parsedZoomValue)) {
		return null;
	}

	return clampPdfPreviewZoom(parsedZoomValue);
};

export const stepPdfPreviewZoom = (zoom: number, direction: 'in' | 'out'): number => {
	const nextZoom = direction === 'in' ? zoom + PDF_PREVIEW_ZOOM_STEP : zoom - PDF_PREVIEW_ZOOM_STEP;

	return Number(clampPdfPreviewZoom(nextZoom).toFixed(2));
};
